// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".budget-table[data-v-4241866b] {\n  padding-left: 40px;\n  box-sizing: border-box;\n}\n.budget-table .budget-head[data-v-4241866b] {\n  display: flex;\n  align-items: center;\n  padding-bottom: 20px;\n}\n.budget-table .budget-head .red[data-v-4241866b] {\n  color: red;\n  margin: 0 10px;\n}\n.budget-table[data-v-4241866b] .el-input__inner {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
